/* Rugged Print, master inserts collection (templates/collection.master.json). Ported from module-10 shared.js. Cards are server-rendered by Liquid from live Shopify data; filter attributes come from the handle map in #rp-mc-map (known limit, see NOTES.md). URL contract: ?category= ?case= ?caliber= ?platform= (comma = OR, groups = AND). */
(function(){
  'use strict';
  var mapEl = document.getElementById('rp-mc-map'), MAP = {};
  try { MAP = JSON.parse(mapEl ? mapEl.textContent : '{}'); } catch (e) { MAP = {}; }
  var gridEl0 = document.getElementById('mc-grid');
  if (!gridEl0) return;
  var cards = Array.prototype.slice.call(gridEl0.querySelectorAll('.pc'));
  if (!cards.length) return;   /* empty collection (coming soon): nothing to filter */
  var D = cards.map(function(el){ var m = MAP[el.getAttribute('data-h')] || [];
    return { handle: el.getAttribute('data-h'), cat: m[0] || null, cs: m[1] || null, cal: m[2] || null, plat: m[3] || null }; });

  /* ---- filter definitions. key = URL param. opts: slug -> label (+ aliases accepted on arrival) ---- */
  var G = [
    { key:'category', field:'cat', title:'Category', opts:[['ammo','Ammo'],['tool','Tool']], alias:{ammo:'ammo',ammunition:'ammo',tool:'tool',tools:'tool'} },
    { key:'case', field:'cs', title:'Case model', opts:[['8435','48-22-8435'],['8436','48-22-8436'],['8431','48-22-8431'],['4-drawer','4-Drawer']],
      alias:{'8435':'8435','4822 8435':'8435','48228435':'8435','8436':'8436','48228436':'8436','8431':'8431','48228431':'8431','4drawer':'4-drawer','fourdrawer':'4-drawer'} },
    { key:'caliber', field:'cal', title:'Caliber', opts:[['9mm','9mm'],['45-acp','.45 ACP'],['380','.380'],['40-sw','.40 S&W'],['38-special','.38 Special'],['22-lr','.22 LR'],
      ['223-556','.223/5.56'],['300-blk','300 BLK'],['308','.308'],['6-5-creedmoor','6.5 Creedmoor'],['7mm-rem-mag','7mm Rem Mag'],['12-gauge','12 Gauge']],
      alias:{'9mm':'9mm','45acp':'45-acp','45':'45-acp','380':'380','380acp':'380','40sw':'40-sw','40':'40-sw','38special':'38-special','38':'38-special','22lr':'22-lr','22':'22-lr',
      '223556':'223-556','223':'223-556','556':'223-556','300blk':'300-blk','300blackout':'300-blk','308':'308','65creedmoor':'6-5-creedmoor','65':'6-5-creedmoor',
      '7mmremmag':'7mm-rem-mag','7mm':'7mm-rem-mag','12gauge':'12-gauge','12ga':'12-gauge','12':'12-gauge'} },
    { key:'platform', field:'plat', title:'Platform', opts:[['m12','M12'],['m18','M18'],['dewalt','DeWalt']], alias:{m12:'m12',m18:'m18',dewalt:'dewalt'} }
  ];
  var CASE_LONG = {'8435':'PACKOUT 48-22-8435','8436':'PACKOUT 48-22-8436','8431':'PACKOUT 48-22-8431','4-drawer':'the PACKOUT 4-Drawer Tool Box'};
  var LABEL = {}; G.forEach(function(g){ LABEL[g.key] = {}; g.opts.forEach(function(o){ LABEL[g.key][o[0]] = o[1]; }); });

  /* ---- helpers ---- */
  function $(s, r){ return (r || document).querySelector(s); }
  function esc(s){ return String(s).replace(/[&<>"]/g, function(c){ return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c]; }); }
  function norm(s){ return String(s).toLowerCase().replace(/[^a-z0-9]+/g, ''); }

  var state = {}; G.forEach(function(g){ state[g.key] = []; });

  /* ---- URL <-> state ---- */
  function readUrl(){
    var q = new URLSearchParams(location.search), any = false;
    G.forEach(function(g){
      state[g.key] = [];
      (q.get(g.key) || '').split(',').forEach(function(v){
        if (!v.trim()) return;
        var slug = g.alias[norm(v)] || (LABEL[g.key][v.trim().toLowerCase()] ? v.trim().toLowerCase() : null);
        if (slug && state[g.key].indexOf(slug) < 0){ state[g.key].push(slug); any = true; }
      });
    });
    return any;
  }
  function writeUrl(){
    var q = new URLSearchParams();
    G.forEach(function(g){ if (state[g.key].length) q.set(g.key, state[g.key].join(',')); });
    var s = q.toString().replace(/%2C/g, ',');
    history.replaceState(null, '', location.pathname + (s ? '?' + s : '') + location.hash);
  }

  /* ---- matching ---- */
  function matches(p, skipKey){
    return G.every(function(g){
      if (g.key === skipKey) return true;
      var sel = state[g.key]; if (!sel.length) return true;
      return p[g.field] && sel.indexOf(p[g.field]) >= 0;
    });
  }
  function anyActive(){ return G.some(function(g){ return state[g.key].length; }); }

  /* ---- render static parts once ---- */
  var gridEl = $('#mc-grid'), panel = $('#mc-panel'), countEl = $('#mc-count'), activeEl = $('#mc-active'), emptyEl = $('#mc-empty');
  var clearBtns = document.querySelectorAll('[data-clear]');

  /* tag row (caliber, platform, case) added from the map; card markup itself is Liquid */
  cards.forEach(function(el, i){ var p = D[i], tags = '';
    if (p.cal) tags += '<span class="pc-tag">' + esc(LABEL.caliber[p.cal]) + '</span>';
    if (p.plat) tags += '<span class="pc-tag">' + esc(LABEL.platform[p.plat]) + '</span>';
    if (p.cs) tags += '<span class="pc-tag">' + esc(LABEL['case'][p.cs]) + '</span>';
    var t = el.querySelector('.pc-tags'); if (t) t.innerHTML = tags; });

  var chipEls = {};
  G.forEach(function(g){
    var f = document.createElement('fieldset'); f.className = 'mc-grp';
    f.innerHTML = '<legend>' + g.title + '</legend><div class="mc-chips"></div>';
    var box = f.querySelector('.mc-chips');
    g.opts.forEach(function(o){
      var total = D.filter(function(p){ return p[g.field] === o[0]; }).length;
      if (!total) return; /* options with no real product are not offered (still accepted from a URL; see empty state) */
      var b = document.createElement('button'); b.type = 'button'; b.className = 'chip'; b.setAttribute('aria-pressed', 'false');
      b.setAttribute('data-g', g.key); b.setAttribute('data-v', o[0]);
      b.innerHTML = esc(o[1]) + ' <span class="n">0</span>';
      b.addEventListener('click', function(){ toggle(g.key, o[0]); });
      box.appendChild(b); chipEls[g.key + ':' + o[0]] = b;
    });
    panel.appendChild(f);
  });

  function toggle(key, v){
    var a = state[key], i = a.indexOf(v);
    if (i >= 0) a.splice(i, 1); else a.push(v);
    update(false);
  }
  function clearAll(){ G.forEach(function(g){ state[g.key] = []; }); update(false); }
  Array.prototype.forEach.call(clearBtns, function(b){ b.addEventListener('click', clearAll); });

  /* ---- heading + intro templates (no claims beyond live facts; see NOTES.md) ---- */
  function names(g){ return state[g.key].map(function(v){ return LABEL[g.key][v] || v; }); }
  function join(a){ return a.length < 3 ? a.join(' and ') : a.slice(0, -1).join(', ') + ' and ' + a[a.length - 1]; }
  function headings(){
    var cat = state.category, cs = state['case'], cal = state.caliber, pl = state.platform;
    var groups = G.filter(function(g){ return state[g.key].length; }).length;
    var h1, sub;
    if (!groups){ h1 = 'PACKOUT Inserts'; sub = 'Browse every insert, or pick a filter to narrow it down.'; }
    else if (groups === 1 && cal.length){ h1 = 'Inserts for ' + join(names(G[2])); sub = 'Ammo inserts made for ' + join(names(G[2])) + ' in Milwaukee PACKOUT cases.'; }
    else if (groups === 1 && cs.length){ var cl = cs.map(function(v){ return CASE_LONG[v]; }); h1 = 'Inserts for ' + join(cl); sub = 'Inserts that fit ' + join(cl) + '.'; }
    else if (groups === 1 && pl.length){
      var pn = names(G[3]); h1 = pl.indexOf('dewalt') >= 0 && pl.length === 1 ? 'DeWalt Tough System Inserts' : join(pn) + ' Tool Inserts';
      sub = 'Tool inserts for the ' + join(pn) + ' platform.';
    }
    else if (groups === 1 && cat.length === 1){ h1 = cat[0] === 'ammo' ? 'Ammo Organizer Inserts' : 'Tool Organizer Inserts'; sub = cat[0] === 'ammo' ? 'Ammo storage inserts for Milwaukee PACKOUT cases.' : 'Tool inserts for Milwaukee PACKOUT cases.'; }
    else if (groups === 1){ h1 = 'PACKOUT Inserts'; sub = 'Ammo and tool inserts for Milwaukee PACKOUT cases.'; }
    else {
      var parts = []; G.forEach(function(g){ if (state[g.key].length) parts.push(join(names(g))); });
      h1 = 'PACKOUT Inserts: ' + parts.join(', '); sub = 'Inserts matching ' + parts.join(', ') + '.';
    }
    return { h1:h1, sub:sub };
  }

  var firstRender = true;
  function update(initial){
    var visible = 0;
    cards.forEach(function(el, i){ var ok = matches(D[i]); el.hidden = !ok; if (ok) visible++; });
    G.forEach(function(g){
      g.opts.forEach(function(o){
        var b = chipEls[g.key + ':' + o[0]]; if (!b) return;
        b.setAttribute('aria-pressed', state[g.key].indexOf(o[0]) >= 0 ? 'true' : 'false');
        /* count = products that would match if this chip were added to the other groups' current picks */
        var n = D.filter(function(p){ return p[g.field] === o[0] && matches(p, g.key); }).length;
        b.querySelector('.n').textContent = n;
      });
    });
    /* active chips */
    activeEl.innerHTML = '';
    G.forEach(function(g){ state[g.key].forEach(function(v){
      var b = document.createElement('button'); b.type = 'button'; b.className = 'chip';
      b.setAttribute('aria-label', 'Remove filter ' + g.title + ' ' + (LABEL[g.key][v] || v));
      b.textContent = (LABEL[g.key][v] || v);
      b.addEventListener('click', function(){ toggle(g.key, v); }); activeEl.appendChild(b);
    }); });
    var act = anyActive();
    Array.prototype.forEach.call(clearBtns, function(b){ b.hidden = !act && b.hasAttribute('data-clear-bar'); });
    var noun = (document.querySelector('.rp-mc[data-noun]') || {}).getAttribute ? (document.querySelector('.rp-mc[data-noun]').getAttribute('data-noun')) : 'inserts'; countEl.textContent = act ? 'Showing ' + visible + ' of ' + D.length + ' ' + noun : D.length + ' ' + noun;
    emptyEl.hidden = visible !== 0; gridEl.hidden = visible === 0;
    var tg = $('#mc-tog'); if (tg){ var cnt = G.reduce(function(a, g){ return a + state[g.key].length; }, 0); tg.querySelector('span').textContent = cnt ? 'Filters (' + cnt + ')' : 'Filters'; }

    var h = headings();
    if (!document.querySelector('.rp-mc[data-static]')) {
    $('#mc-h1').textContent = h.h1;
    $('#mc-sub').textContent = h.sub;
    var t = h.h1 + ' | Rugged Print'; document.title = t;
    var md = document.querySelector('meta[name=description]');
    if (md) md.content = h.sub + ' 3D printed from PETG in Arizona. Sold as insert only; the Milwaukee PACKOUT case is not included.';
    $('#mc-crumb-cur').textContent = act ? h.h1 : 'PACKOUT Inserts';
    }
    if (!initial) writeUrl();
    firstRender = false;
  }

  /* ---- mobile filter toggle ---- */
  var tog = $('#mc-tog');
  function mobile(){ return window.matchMedia('(max-width:767px)').matches; }
  function setPanel(open){ panel.hidden = !open; tog.setAttribute('aria-expanded', open ? 'true' : 'false'); }
  if (tog) tog.addEventListener('click', function(){ setPanel(panel.hidden); });   /* empty collections (coming soon) have no filter toggle */

  /* ---- boot ---- */
  var hadParams = readUrl();
  update(true);
  setPanel(true); /* filters always open by default (scroll up to see them); arriving with a filter scrolls to the results */
  if (hadParams){
    var go = function(){
      var a = $('#mc-grid') || $('.mc-bar'); if (!a) return;
      var hd = document.querySelector('sticky-header .header-wrapper') || document.querySelector('.header-wrapper') || document.querySelector('header');
      var off = hd ? hd.getBoundingClientRect().height : 0;
      var y = a.getBoundingClientRect().top + window.pageYOffset - off - 8;
      window.scrollTo(0, Math.max(0, y));
    };
    requestAnimationFrame(function(){ requestAnimationFrame(go); });
    window.addEventListener('load', go);
  }
  window.addEventListener('popstate', function(){ readUrl(); update(true); });
})();
